var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center",staticStyle:{"min-height":"500px"},attrs:{"id":"loginPage"}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"8","md":"6"}},[_c('loginForm')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }